import React from 'react'
import {makeStyles, Typography} from '@material-ui/core';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import DoubleButton from 'components/popup/components/DoubleButton';
import Select from 'components/Select';
import VS from 'constants/ValidationShema';
import PropTypes from "prop-types";

const useStyle = makeStyles(theme => ({
    gridContainer: {
        marginBottom: theme.spacing(2)
    },
    fileName: {
        width: 400
    },
    select: {
        width: 350,
        marginLeft: theme.spacing(2)
    },

}));

function SelectMembersDocumentType(
    {
        items,
        types,
        onCancel,
        onSubmit,
        formSubmit,
    }) {

    const classes = useStyle();

    const formId = useId();
    const selectId = 'item';

    const createSelectTab = () => {
        if (types === undefined) return '';
        return Object.keys(types).map(x => ({value: x, label: types[x]}));
    }

    const generateItems = (formikProps) => {
        if (items.length === 0) {
            return <Typography>{Tr("file_extension_error")}</Typography>
        }
        return items.map((item, i) => {
            return (
                <GridBlock key={i} justify="space-between" alignItems="center">
                    <Typography className={classes.fileName}> {item.name}</Typography>

                    <Select
                        id={selectId + i}
                        formikProps={formikProps}
                        items={createSelectTab()}
                        label={Tr('document_type')}
                        className={classes.select}
                    />

                </GridBlock>
            )
        })
    };

    const submitForm = () => {
        formSubmit[formId]()
    };

    const generateInitialValues = () => {
        let obj = {};
        for (let i = 0; i < items.length; i++) {
            obj[selectId + i] = "";
        }
        return obj
    };

    const generateValidationSchema = () => {
        let obj = {};
        for (let i = 0; i < items.length; i++) {
            obj[selectId + i] = VS.string();
        }

        return VS.object(obj)
    };

    const handleSubmit = (values) => onSubmit(values, items)

    if (items === undefined) return '';
    return (
        <Dialog
            open
            title={Tr('select_document_type')}
            titleCentered

            maxWidth={'xl'}
            fullWidth={false}
            paperClassName={classes.paperClassName}
            dialogActions={<DoubleButton
                justify='flex-end'
                labelFirst={Tr('cancel')}
                labelSecond={Tr('add')}
                onClickFirst={onCancel}
                onClickSecond={submitForm}
            />}
        >
            <Form
                onSubmit={handleSubmit}
                id={formId}
                initialValues={generateInitialValues()}
                validationSchema={generateValidationSchema()}
            >
                {(formikProps) => (
                    <>
                        <GridBlock column className={classes.gridContainer}>
                            {generateItems(formikProps)}
                        </GridBlock>
                    </>
                )}
            </Form>

        </Dialog>
    )
}

SelectMembersDocumentType.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired
    })).isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default connect((state) => ({
    formSubmit: state.form
}), {})(SelectMembersDocumentType);